import { readonly } from 'vue';

const UI_ELEMENTS_IDS = readonly({
    MASS_LOCKS_GRID: 729,
    ALL_LOCKS_GRID: 730,
});

export default {
    UI_ELEMENTS_IDS
}
